import { DotLottieReact } from "@lottiefiles/dotlottie-react";

import { Button } from "@similarweb/ui-components";

import { AssetsService } from "app/services/AssetsService";
import { ProModal } from "pro-features/components/Modals/src/ProModal";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import { STATIC_LIST_PAGE_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { modalStyles, StyledCloseButton, StyledModalFooter, StyledTitle } from "./styles";

type Props = {
    title: string;
    listId?: string;
    onClose?: VoidFunction;
    onStayOnPage?: VoidFunction;
    onGoToList?: VoidFunction;
};

export const OpportunityListUpdatedModal = (props: Props) => {
    const translate = useTranslation();

    const handleClickOnClose = () => {
        props.onClose?.();
        props.onStayOnPage?.();
    };

    const goToList = () => {
        props.onGoToList?.();
        props.onClose?.();
        void proNavigator.go(STATIC_LIST_PAGE_ROUTE, { id: props.listId }, { reload: true });
    };

    return (
        <ProModal
            isOpen={!!props.listId}
            showCloseIcon={false}
            shouldCloseOnOverlayClick={false}
            customStyles={modalStyles}
        >
            <StyledTitle>{props.title}</StyledTitle>
            <DotLottieReact
                src={AssetsService.assetUrl("/images/sales-intelligence/hoorayAnimation.lottie")}
                autoplay
                loop={false}
                style={{ width: "230px", height: "230px", margin: "0px auto" }}
                segment={[0, 30]}
            />
            <StyledModalFooter>
                <StyledCloseButton
                    onClick={handleClickOnClose}
                    type="flat"
                >
                    {translate("si.opportunity-list-updated-modal.close")}
                </StyledCloseButton>
                <Button onClick={goToList}>{translate("si.opportunity-list-updated-modal.go-to-list")}</Button>
            </StyledModalFooter>
        </ProModal>
    );
};
